import React from 'react';

import ActivationStepContent from './ActivationGate/ActivationStepContent';
import ActivationWizardModal from './ActivationGate/ActivationWizardModal';
import { useCollaboratorActivationWizard } from '../hooks/useCollaboratorActivationWizard';
import { CreateCommissioningCollaboratorFormState } from '../types';

type Props = {
  open: boolean;
  isBrokerAdmin: boolean;
  isEstateAdmin: boolean;
  defaultEstateId: string;
  estateOptions: Array<{ key: string; text: string; value: string }>;
  saving: boolean;
  onClose: () => void;
  onSubmit: (form: CreateCommissioningCollaboratorFormState) => void;
};

const CreateCollaboratorModal: React.FC<Props> = ({
  open,
  isBrokerAdmin,
  isEstateAdmin,
  defaultEstateId,
  estateOptions,
  saving,
  onClose,
  onSubmit
}) => {
  const wizard = useCollaboratorActivationWizard({
    open,
    mode: 'create',
    isBrokerAdmin,
    isEstateAdmin,
    defaultEstateId,
    estateOptions
  });

  const handleFinish = () => {
    if (!wizard.validateAllSteps()) return;

    onSubmit({
      ...wizard.form,
      estateId: wizard.selectedEstateId
    });
  };

  return (
    <ActivationWizardModal
      open={open}
      title="Adicionar colaborador"
      finishButtonText="Confirmar cadastro"
      closeOnDimmerClick={false}
      onClose={onClose}
      activationStep={wizard.activationStep}
      lastActivationStep={wizard.lastActivationStep}
      activationSaving={saving}
      activationStepError={wizard.activationStepError}
      recipientType={wizard.form.recipientType}
      onBack={() => wizard.handleBackStep(onClose)}
      onNext={wizard.handleNextStep}
      onFinish={handleFinish}
    >
      <ActivationStepContent
        mode="collaborator"
        activationStep={wizard.activationStep}
        activationForm={wizard.form}
        updateActivationFormField={wizard.updateFormField}
        handleZipCodeLookup={wizard.handleZipCodeLookup}
        addressLookupLoading={wizard.addressLookupLoading}
        addressLookupError={wizard.addressLookupError}
        addressAutoFilled={wizard.addressAutoFilled}
        isBrokerAdmin={isBrokerAdmin}
        estateOptions={estateOptions}
        userOptions={wizard.userOptions}
        usersLoading={wizard.usersLoading}
        selectedEstateId={wizard.selectedEstateId}
        onEstateChange={wizard.setEstateId}
        onUserChange={wizard.applySelectedUser}
      />
    </ActivationWizardModal>
  );
};

export default CreateCollaboratorModal;
